import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWarningIconOrange = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 12,
			fill: "#FFB800"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 5.70898L12 13.6607",
			stroke: "white",
			strokeWidth: 2.23271
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 15.9141L12 17.827",
			stroke: "white",
			strokeWidth: 2.23271
		})
	]
});
export default SvgWarningIconOrange;
